(async () => {

  if (!customElements.get('product-recommendations')) {

    const { default: Swiper} = await import("swiper");
    class ProductRecommendations extends HTMLElement {
      constructor() {
        super();

        this.swiperElement = this.querySelector('[data-swiper-recommended-products]');

        this.swiperOptions = {
          loop: false,
          autoplay: false,
          direction: 'horizontal',
          spaceBetween: 16,
          breakpoints: {
            320: {
              slidesPerView: 2
            },
            768: {
              slidesPerView: 4
            }
          }
        }

        // Check if we have extra options on the HTML
        if (this && this.dataset && this.dataset.options) {
          const jsonOptions = JSON.parse(this.dataset.options);

          if (jsonOptions) {
            this.swiperOptions = {
              ...this.swiperOptions,
              ...jsonOptions
            }
          }
        }

        this.swiperInstance = new Swiper(this.swiperElement, this.swiperOptions);

        window.onload = () => {
          this.init();
        }
      }

      init() {
        if (this.dataset && this.dataset.url) {
          fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const source = html.querySelector('[data-recommended-products]');
            const target = this.querySelector('[data-recommended-products]');

            // Hide the whole product recommendations when there is noting returned.
            if(source.children.length === 0) {
              this.classList.add('hidden');
              return;
            }

            if (source && source.innerHTML && source.innerHTML.trim().length) {
              target.innerHTML = source.innerHTML;
            }

            this.swiperInstance.update();
          })
          .catch(e => {
            console.error(e);
          });
        }
      }
    }

    window.ProductRecommendations = ProductRecommendations;

    customElements.define('product-recommendations', ProductRecommendations);

  }

})();
